module.exports = __webpack_public_path__ + "img/map-hotel.435c2b85.png";